export default __webpack_public_path__ + "static/media/ic_number_tray.428679fb.png";